import { useUserContext } from "../../context/UserContext";
import OnlineMenuService, { StatisticIdentifiers } from "../../api/service/OnlineMenuService";
import { SyntheticEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../__product__/navigation/routes";
import { OnlineMenuModel } from "../../api/model/response/OnlineMenuResponseModel";
import { useMyNavigate } from "../../__product__/navigation/myNavigate";

const OnlineMenuHomeHook = () => {
  const { currentOnlineMenu, currentCompanyInfo } = useUserContext();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const navigate = useMyNavigate();

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
    navigate(`${routes.food}/${currentOnlineMenu?.categoriesObj[newValue].id}`);
  };
  useEffect(() => {
    handleChangeCategory(currentOnlineMenu);
  }, [useLocation()]);

  useEffect(() => {
    if (!currentOnlineMenu?.title) {
      setIsLoading(true);
    } else {
      handleChangeCategory(currentOnlineMenu);
      setIsLoading(false);
    }
  }, [currentOnlineMenu]);

  function handleChangeCategory(menu: OnlineMenuModel) {
    const indexOfWindow = window.location.pathname?.split("/").slice(-1)[0];
    const selectedCategory = menu.categoriesObj?.find((x) => x.id === indexOfWindow);
    if (selectedCategory) {
      setSelectedTab(menu?.categoriesObj?.indexOf(selectedCategory));
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  return {
    currentCompanyInfo,
    currentOnlineMenu,
    isLoading,
    selectedTab,
    openBottomSheet,
    setSelectedTab,
    setOpenBottomSheet,
    handleTabChange
  };
};
export default OnlineMenuHomeHook;
